import StoreWarsImage from "../assets/ProjectImages/StoreWars.jpg";
import DawnmakerImage from "../assets/ProjectImages/Dawnmaker.jpg";
import EXOMEImage from "../assets/ProjectImages/EXOME.jpg";
import TaxiChaosImage from "../assets/ProjectImages/TaxiChaos.jpg";
import FoundersFortuneImage from "../assets/ProjectImages/FoundersFortune.jpg";
import WarplanesImage from "../assets/ProjectImages/Warplanes.jpg";
import EndhallImage from "../assets/ProjectImages/Endhall.jpg";
import StellarHubImage from "../assets/ProjectImages/StellarHub.jpg";
import { ProjectItem } from "../Types/ProjectsItem";

export const ProjectList = (): ProjectItem[] => [
  {
    id: 0,
    image: StoreWarsImage,
    projectName: "Store Wars",
    projectDescription: "Multiplayer store management game supporting up to 16 concurrent players with real-time co-op and PvP interactions.",
    company: "Noham Games",
    role: "Senior Gameplay Engineer",
    engine: "Unreal Engine 5",
    officialLink: "https://store.steampowered.com/app/3213600/Store_Wars_Multiplayer_Shop_Simulator/",
    date: "2025",
  },
  {
    id: 1,
    image: DawnmakerImage,
    projectName: "Dawnmaker",
    projectDescription: "Hex-grid city building deckbuilder with strategic card synergies and data-driven progression systems.",
    company: "Arpentor Studio",
    role: "Senior Gameplay Engineer",
    engine: "Unity",
    officialLink: "https://arpentor.studio/games/dawnmaker/",
    date: "2024",
  },
  {
    id: 2,
    image: EXOMEImage,
    projectName: "EXOME",
    projectDescription: "Co-op survival shooter with wave-based enemy spawning, weapon progression, and open-world exploration for up to 4 players.",
    company: "RudeFrog Studios",
    role: "Gameplay Engineer",
    engine: "Unreal Engine 5",
    officialLink: "https://rudefrogstudios.com/",
    date: "2022",
  },
  {
    id: 3,
    image: TaxiChaosImage,
    projectName: "Taxi Chaos",
    projectDescription: "Arcade-style taxi driving game with dynamic passenger systems and time-pressure delivery mechanics.",
    company: "Team6 Game Studios",
    role: "Gameplay Engineer",
    engine: "Unreal Engine",
    officialLink: "https://www.lion-castle.com/games/taxi-chaos/",
    date: "2021",
  },
  {
    id: 4,
    image: FoundersFortuneImage,
    projectName: "Founders' Fortune",
    projectDescription: "Colony builder with modular colonist simulation featuring personality traits, mood mechanics, and resource management.",
    company: "Dionic Software",
    role: "Gameplay Engineer",
    engine: "Unity",
    officialLink: "https://dionicsoftware.com/",
    date: "2020",
  },
  {
    id: 5,
    image: WarplanesImage,
    projectName: "Warplanes: WW1 Sky Aces",
    projectDescription: "WW1 flight combat game with physics-based aircraft handling and FSM-driven enemy AI.",
    company: "Home Net Games",
    role: "Gameplay Engineer",
    engine: "Unity",
    officialLink: "https://www.homenetgames.com/warplanes-ww1-sky-aces/",
    date: "2019",
  },
  {
    id: 6,
    image: EndhallImage,
    projectName: "Endhall",
    projectDescription: "Turn-based roguelike with procedural hallway generation and grid-based enemy behavior.",
    company: "Heartbeast",
    role: "Junior Gameplay Engineer",
    engine: "Godot",
    officialLink: "https://uheartbeast.itch.io/endhall",
    date: "2018",
  },
  {
    id: 7,
    image: StellarHubImage,
    projectName: "StellarHub",
    projectDescription: "Space station management sim with crew personality traits, needs simulation, and behavior-driven task assignment.",
    company: "Casualogic",
    role: "Junior Gameplay Engineer",
    engine: "Godot",
    officialLink: "https://store.steampowered.com/app/672860/StellarHub/",
    date: "2017",
  },
];
